if (!customElements.get('compatible-products-table')) {
  class CompatibleProductsTable extends HTMLElement {
    constructor() {
      super();

      if (window.initLazyScript) {
        window.initLazyScript(this, this.init.bind(this), 300);
      } else {
        this.init();
      }
    }

    init() {
      if (this.initialized) return;

      this.visibleRows = Number.parseInt(this.dataset.visibleRows, 10) || 10;
      this.showLabel = this.dataset.showLabel || 'Show all compatible products';
      this.hideLabel = this.dataset.hideLabel || 'Show fewer compatible products';
      this.countLabel = this.dataset.countLabel || 'Showing 10 of [count] compatible products';
      this.tables = Array.from(this.querySelectorAll('.parts-table-container table'));
      this.language = (this.dataset.language || 'en').toLowerCase();

      if (!this.tables.length) return;

      this.hiddenRows = [];
      this.totalDataRows = 0;

      this.tables.forEach((table) => this.prepareTable(table));

      if (this.totalDataRows <= this.visibleRows || !this.hiddenRows.length) return;

      this.renderToggle();
      this.setExpanded(false);

      this.initialized = true;
    }

    prepareTable(table) {
      this.cleanTableDimensions(table);
      const rows = this.getDataRows(table);

      if (!rows.length) return;

      this.totalDataRows += rows.length;

      rows.forEach((row, index) => {
        if (index >= this.visibleRows) {
          row.classList.add('parts-table-row--hidden');
          row.dataset.compatibleTableHiddenRow = 'true';
          this.hiddenRows.push(row);
        }
      });
    }

    cleanTableDimensions(table) {
        const elements = [table, ...table.querySelectorAll('tr, th, td, col, colgroup')];

        elements.forEach((el) => {
         el.removeAttribute('width');
         el.removeAttribute('height');

        el.style.removeProperty('width');
        el.style.removeProperty('height');
        el.style.removeProperty('min-width');
        el.style.removeProperty('min-height');
        el.style.removeProperty('max-width');
        el.style.removeProperty('max-height');

        if (!el.getAttribute('style')) {
            el.removeAttribute('style');
        }
        });
    }

    getDataRows(table) {
      const tbodyRows = Array.from(table.querySelectorAll('tbody tr'));

      if (tbodyRows.length) {
        return tbodyRows;
      }

      const allRows = Array.from(table.querySelectorAll('tr'));

      if (!allRows.length) return [];

      const firstRow = allRows[0];
      const firstRowLooksLikeHeader = firstRow.querySelectorAll('th').length > 0;

      return firstRowLooksLikeHeader ? allRows.slice(1) : allRows;
    }

    renderToggle() {
      this.status = document.createElement('p');
      this.status.className = 'parts-table-container__status text-sm text-theme-light mb-3';
      this.status.id = `compatible-products-table-status-${Math.random().toString(36).slice(2)}`;

      this.button = document.createElement('button');
      this.button.type = 'button';
      this.button.className = 'btn btn--secondary parts-table-container__toggle';
      this.button.setAttribute('aria-expanded', 'false');
      this.button.setAttribute('aria-describedby', this.status.id);
      this.button.textContent = this.showLabel;

      this.button.addEventListener('click', () => {
        const isExpanded = this.button.getAttribute('aria-expanded') === 'true';
        this.setExpanded(!isExpanded);
      });

      const actions = document.createElement('div');
      actions.className = 'parts-table-container__actions flex flex-col items-start mt-4';
      actions.append(this.status, this.button);

      this.querySelector('.parts-table-container')?.append(actions);
    }

    getExpandedStatusText() {
      if (this.language !== 'en') {
        return `Affichage des ${this.totalDataRows} produits compatibles`;
      }

      return `Showing all ${this.totalDataRows} compatible products`;
    }

    setExpanded(expanded) {
      this.hiddenRows.forEach((row) => {
        row.classList.toggle('parts-table-row--hidden', !expanded);
      });

      this.button.setAttribute('aria-expanded', String(expanded));
      this.button.textContent = expanded ? this.hideLabel : this.showLabel;

      this.status.textContent = expanded
          ? this.getExpandedStatusText()
          : this.countLabel.replace('[count]', this.totalDataRows);

      if (!expanded && this.button.matches(':focus')) {
        this.scrollIntoComfortableView();
      }
    }

    scrollIntoComfortableView() {
      const rect = this.getBoundingClientRect();
      const headerOffset = Number.parseInt(
        getComputedStyle(document.documentElement).getPropertyValue('--header-height'),
        10
      ) || 0;

      if (rect.top < headerOffset || rect.top > window.innerHeight * 0.5) {
        window.scrollTo({
          top: window.scrollY + rect.top - headerOffset - 24,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }
    }
  }

  customElements.define('compatible-products-table', CompatibleProductsTable);
}